import relationshipRule from '@/http/requests/relationshipRules'

export default {
  fetchPaginated({ commit }, data) {
    return new Promise((resolve, reject) => {
      relationshipRule.fetchPaginated(data.sortName, data.page, data.itemsPerPage, data.type, data.word)
        .then((response) => {
          const parsedData = response.data.data.getRelationshipRulePaginated;

          commit('SET_RELATIONSHIP_RULE_PAGINATED', parsedData);
          resolve(response);
        })
        .catch((exception) => {
          reject(exception);
        });
    })
  },
}
